"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitPurpose = exports.VisitStatus = void 0;
// Optional: Create an enum for visit status if needed
var VisitStatus;
(function (VisitStatus) {
    VisitStatus["SCHEDULED"] = "SCHEDULED";
    VisitStatus["IN_PROGRESS"] = "IN_PROGRESS";
    VisitStatus["COMPLETED"] = "COMPLETED";
    VisitStatus["CANCELLED"] = "CANCELLED";
    VisitStatus["NO_SHOW"] = "NO_SHOW";
})(VisitStatus = exports.VisitStatus || (exports.VisitStatus = {}));
var VisitPurpose;
(function (VisitPurpose) {
    VisitPurpose["CAR_VIEWING"] = "CAR_VIEWING";
    VisitPurpose["SELL_MY_CAR"] = "SELL_MY_CAR";
})(VisitPurpose = exports.VisitPurpose || (exports.VisitPurpose = {}));
